"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertBannerToBannerData = exports.convertOfferToBannerData = exports.isNil = void 0;
function isNil(x) {
    return x === null || x === undefined;
}
exports.isNil = isNil;
function getDynamicParams(newDynamicParams) {
    var dynamicParams = {};
    for (var propName in newDynamicParams) {
        if (!isNil(newDynamicParams[propName])) {
            dynamicParams[propName] = newDynamicParams[propName];
        }
    }
    return dynamicParams;
}
function convertOfferToBannerData(offer) {
    var offerDynamicParams = offer.asset.dynamicParams || {};
    var dynamicParams = getDynamicParams(offerDynamicParams);
    var payload = JSON.parse(offer.asset.payloadJson);
    var bannerData = {
        bannerPosition: offer.realEstateId,
        bannerId: payload.templateId,
        bannerTemplate: payload.template,
        lightboxTriggers: payload.triggers,
        lightboxGuid: offer.offerGuid,
        dynamicParams: dynamicParams,
        saleType: offerDynamicParams.SALE_TYPE,
        isPremium: undefined,
        daysLeft: !isNil(offerDynamicParams.DAYS_LEFT)
            ? parseInt(offerDynamicParams.DAYS_LEFT, 10)
            : undefined,
    };
    return bannerData;
}
exports.convertOfferToBannerData = convertOfferToBannerData;
var salesTypeMapper = {
    UNKNOWN: undefined,
    SEASONAL: 'Seasonal',
    SEASONAL_EXTENDED: 'SeasonalExtended',
    PERSONAL: 'Personal',
    CUSTOM: 'Custom',
};
function convertBannerToBannerData(banner) {
    var _a, _b, _c;
    var triggers = ((_a = banner.metadata) === null || _a === void 0 ? void 0 : _a.lbConfig) ? {
        delayOpenSec: banner.metadata.lbConfig.delayOpenSec,
        displayStyle: banner.metadata.lbConfig.displayStyle,
        ttlSecSameLB: banner.metadata.lbConfig.ttlSecSameLb,
        ttlSecAnyLB: banner.metadata.lbConfig.ttlSecAnyLb,
    } : undefined;
    return {
        bannerPosition: banner.placementId,
        bannerId: banner.templateData.bannerId,
        bannerTemplate: JSON.stringify(banner.templateData.bannerTemplate),
        lightboxTriggers: JSON.stringify(triggers),
        lightboxGuid: banner.offerGuid,
        dynamicParams: banner.dynamicParams,
        saleType: salesTypeMapper[banner.salesInfo.salesType],
        isPremium: undefined,
        daysLeft: ((_b = banner.salesInfo) === null || _b === void 0 ? void 0 : _b.daysLeft) ? (_c = banner.salesInfo) === null || _c === void 0 ? void 0 : _c.daysLeft : undefined,
    };
}
exports.convertBannerToBannerData = convertBannerToBannerData;
//# sourceMappingURL=toDomain.js.map